/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Box } from '@material-ui/core';

import styles from './styles';

import PageContainer from 'components/PageContainer';
import Title from 'components/Title';
import HorizontalRule from 'components/HorizontalRule';

import useTranslate, {
  useMarkdownTranslate,
} from 'hooks/useTranslate/useTranslate';

import cart from 'features/unified/assets/cart.png';
import { conformToMask, decimalMoneyMask } from 'utils/masks';

import BackToPrevious from 'components/unified/BackToPrevious';
import BreadIcon from '../BreadIcon';

interface PropTypes {
  capacityValue: number;
}

const SplitPayLearnMoreView: React.FC<PropTypes> = props => {
  const { capacityValue } = props;
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  return (
    <PageContainer>
      <Box mb={2}>
        <Title css={styles.pageTitleText}>
          <BreadIcon
            logo={t('unified.offer.splitPayLearnMore.breadLogo')}
            id={'splitpayBreadLogo'}
          />
          {tMd('unified.offer.splitPayLearnMore.title')}
        </Title>
      </Box>

      <Box mb={3} css={styles.subtitleText}>
        {tMd('unified.offer.splitPayLearnMore.subtitle')}
      </Box>

      <div css={styles.hrContainer}>
        <HorizontalRule />
      </div>

      <Box mb={4} css={styles.bodyContainer}>
        {tMd('unified.offer.splitPayLearnMore.body', {
          amount: conformToMask(capacityValue.toFixed(2), decimalMoneyMask),
        })}
      </Box>

      <Box mb={4} css={styles.shadedRoundedContainer}>
        <img src={cart} alt="Checkout" css={styles.cartIcon} />
        <div>
          <div css={styles.checkoutTitle}>
            {t('unified.offer.splitPayLearnMore.checkoutTitle')}
          </div>
          {tMd('unified.offer.splitPayLearnMore.checkout')}
        </div>
      </Box>
      <BackToPrevious tMdKey="unified.offer.splitPayLearnMore.BackToPrevious" />
    </PageContainer>
  );
};

export default SplitPayLearnMoreView;
